var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-section',{attrs:{"gap":"xl","gutter-y":"medium","gutter-x":"","contain":"","center":""}},[_c('SectionHeader',{attrs:{"title":_vm.$t('shop.title'),"description":_vm.$t('shop.description'),"title-tag":"h1"}},[_c('RegisterButton')],1),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":"/eshop/header-image.png","alt":"Statica"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }